import { BATCH_MODE, MODE } from '@/model/search-agent/rating'

export default {
    title: 'Identified micro-trends',
    [MODE.UNVOTED]: 'unassigned',
    [MODE.REJECTED]: 'declined',
    [MODE.ACCEPTED]: 'accepted',
    batch: {
        [BATCH_MODE.acceptAll]: 'accept all',
        [BATCH_MODE.rejectAll]: 'decline all'
    },
    success: {
        [BATCH_MODE.rejectAll]: 'The micro-trends were successfully declined.',
        [BATCH_MODE.acceptAll]: 'The micro-trends were successfully added to the work space.'
    }
}
